import { useMobile as e } from "../../../hooks/useMobile.mjs";
import { CalendarMonth as t } from "./CalendarMonth.mjs";
import { Divider as n, InlineDual as r } from "../styled/Popups.styled.mjs";
import { useCalendarNavigation as i } from "../hooks/useCalendarNavigation.mjs";
import { useCallback as a } from "react";
import { useTranslation as o } from "@maat/store-i18n";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
//#region src/components/DatePicker/components/DateMultiCalendar.tsx
var l = ({ value: l, onChange: u, minDate: d, maxDate: f, className: p, annotations: m, blockedRanges: h, onLoadMore: g, loading: _, months: v = 2, defaultMonth: y }) => {
	let { t: b } = o("ds"), { isMobile: x } = e(), { view: S, navigate: C, nextMonth: w, nextYear: T } = i({
		defaultMonth: y,
		onLoadMore: g
	}), E = {
		selectedDates: l,
		onDayClick: a((e) => {
			let t = l ?? [];
			u?.(t.includes(e) ? t.filter((t) => t !== e) : [...t, e]);
		}, [l, u]),
		minDate: d,
		maxDate: f,
		annotations: m,
		blockedRanges: h,
		loading: _
	};
	return x || v === 1 ? /* @__PURE__ */ s("div", {
		className: p,
		role: "dialog",
		"aria-label": b("ds:datePicker.dialogLabel"),
		children: /* @__PURE__ */ s(t, {
			year: S.year,
			month: S.month,
			onPrev: () => C(-1),
			onNext: () => C(1),
			...E,
			fluid: !0
		})
	}) : /* @__PURE__ */ c(r, {
		className: p,
		role: "dialog",
		"aria-label": b("ds:datePicker.dialogLabel"),
		children: [
			/* @__PURE__ */ s(t, {
				year: S.year,
				month: S.month,
				onPrev: () => C(-1),
				onNext: () => C(1),
				...E,
				hideNext: !0
			}),
			/* @__PURE__ */ s(n, {}),
			/* @__PURE__ */ s(t, {
				year: T,
				month: w,
				onPrev: () => C(-1),
				onNext: () => C(1),
				...E,
				hidePrev: !0
			})
		]
	});
};
//#endregion
export { l as DateMultiCalendar };
